import { pageURLs } from "@/constants";

// Builds the direct-message thread URL for notification links. The separate
// /mobile/direct-messages route was removed with the mobile platform, so a
// notification on a phone must open the same page as on desktop.
export const directMessageUrl = (senderId) =>
  senderId == null || senderId === ""
    ? pageURLs.directMessages
    : `${pageURLs.directMessages}?id=${encodeURIComponent(senderId)}`;
